import { render } from "./AddToast.vue?vue&type=template&id=2f956a2d&scoped=true"
import script from "./AddToast.vue?vue&type=script&lang=js"
export * from "./AddToast.vue?vue&type=script&lang=js"

import "./AddToast.vue?vue&type=style&index=0&id=2f956a2d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f956a2d"]])

export default __exports__